import { render, staticRenderFns } from "./TucowsRegistrarList.vue?vue&type=template&id=504a03ba"
import script from "./TucowsRegistrarList.vue?vue&type=script&lang=js"
export * from "./TucowsRegistrarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports